import { useEffect, useState } from "react";
import "./giveFeedback.css";
import "./needHelp.css";
import axiosInstance from "../../axios";

const NeedHelp = () => {
  const [showPopUP, setShowPopUP] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Payment Issues");
  const [issueDescription, setIssueDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [raisedIssue, setRaisedIssue] = useState(false);
  const userId = JSON.parse(localStorage.getItem("userDetails")).userId;
  const [needHelpData, setNeedHelpData] = useState([]);

  const issueCategories = [
    "Demo Class Issue",
    "Payment Issues",
    "Tutor Availability",
    "Website/App Functionality Issues",
    "General Inquiry",
  ];

  const handleSubmit = e => {
    e.preventDefault();

    // Validate description
    if (!issueDescription.trim()) {
      setDescriptionError(true);
      return;
    }
    setIsLoading(true);
    // Clear error and submit
    setDescriptionError(false);

    axiosInstance
      .post(`/v1/need-help`, {
        userId: userId,
        need_help: selectedCategory,
        custom_text: issueDescription,
        status: "pending",
      })
      .then(data => {
        if (data.data.is_success) {
          setShowPopUP(false);
          setIssueDescription("");
          setSelectedCategory("Payment Issues");
          setRaisedIssue(true);
          getNeedHelp();
        }
      })
      .finally(() => {
        setShowPopUP(false);
        setIsLoading(false);
      });
  };

  const getNeedHelp = () => {
    axiosInstance.get(`/v1/need-help?userId=${userId}`).then(response => {
      if (response.data.is_success) {
        setNeedHelpData(response.data.data);
        if (response.data.data.length > 0) {
          setRaisedIssue(true);
        }
      }
    });
  };

  const handleDescriptionChange = e => {
    setIssueDescription(e.target.value);
    // Clear error when user starts typing
    if (descriptionError && e.target.value.trim()) {
      setDescriptionError(false);
    }
  };

  useEffect(() => {
    getNeedHelp();
  }, [userId]);

  return (
    <>
      {raisedIssue ? (
        <div className="need-help-container">
          <div className="success-message">
            <h2>✅ Issue Raised Successfully</h2>
            <p>We will get back to you soon with a solution.</p>
          </div>
          <div className="new-issue-section">
            <button className="new-raise-btn" onClick={() => setShowPopUP(true)}>
              + Raise New Issue
            </button>
          </div>
          {needHelpData?.map(item => (
            <div key={item.id} className="issue-card">
              <div className="issue-header">
                <h3 className="issue-title">{item.help}</h3>
                <span className={`issue-status ${(item.status || "pending").toLowerCase()}`}>
                  {item.status || "Pending"}
                </span>
              </div>
              <p className="issue-description">{item.custom_text || "No description provided"}</p>
              <div className="issue-meta">
                <span className="issue-date">
                  Submitted on{" "}
                  {new Date(item.created_at).toLocaleDateString(undefined, {
                    year: "numeric",
                    month: "short",
                    day: "2-digit",
                  })}
                </span>
                <span className="issue-priority">High Priority</span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="need-help-container">
          <div className="empty-state">
            <h2>🤝 Need Help?</h2>
            <p>We're here to help you with any issues or questions you might have.</p>
            <button className="raise-issue-btn" onClick={() => setShowPopUP(true)}>
              Raise New Issue
            </button>
          </div>
        </div>
      )}
      {showPopUP && (
        <div className="feedback-modal-overlay">
          <div className="feedback-modal">
            <button className="close-button" onClick={() => setShowPopUP(false)}>
              ×
            </button>

            <div className="feedback-content">
              <h2 className="help-title">Select the issue category to help us resolve your concern quickly.</h2>

              <form onSubmit={handleSubmit}>
                <div className="radio-group">
                  {issueCategories.map(category => (
                    <label key={category} className="radio-option">
                      <input
                        type="radio"
                        name="issueCategory"
                        value={category}
                        checked={selectedCategory === category}
                        onChange={e => setSelectedCategory(e.target.value)}
                        className="radio-input"
                      />
                      <span className="radio-custom"></span>
                      <span className="radio-label">{category}</span>
                    </label>
                  ))}
                </div>

                <div className="description-section">
                  <label className="description-label">
                    Briefly describe the issue <span className="required-asterisk">*</span>
                  </label>
                  <textarea
                    className={`feedback-textarea need-help-textarea ${descriptionError ? "error" : ""}`}
                    placeholder="Type here"
                    value={issueDescription}
                    onChange={handleDescriptionChange}
                  />
                  {descriptionError && (
                    <div className="error-message">
                      Description cannot be empty. Please provide details about your issue.
                    </div>
                  )}
                </div>

                <button type="submit" className="submit-button mt-2" disabled={isLoading}>
                  {isLoading ? "Submitting..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NeedHelp;
